/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyInfo
 */
export interface CompanyInfo {
    /**
     * 
     * @type {string}
     * @memberof CompanyInfo
     */
    someInformationAboutCompany: string;
}

export function CompanyInfoFromJSON(json: any): CompanyInfo {
    return CompanyInfoFromJSONTyped(json, false);
}

export function CompanyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'someInformationAboutCompany': json['some_information_about_company'],
    };
}

export function CompanyInfoToJSON(value?: CompanyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'some_information_about_company': value.someInformationAboutCompany,
    };
}


